import { render } from "./providerCRUD.vue?vue&type=template&id=255f4646&scoped=true"
import script from "./providerCRUD.vue?vue&type=script&lang=js"
export * from "./providerCRUD.vue?vue&type=script&lang=js"

import "./providerCRUD.vue?vue&type=style&index=0&id=255f4646&scoped=true&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255f4646"]])

export default __exports__